import React from 'react'
import PropTypes from 'prop-types'
import {Flex, useMultiStyleConfig} from '@chakra-ui/react'
import ProductTile from '../../../components/product-tile'
import {CompareProvider} from '../../../context/compare'
import NewsletterBanner from '../../../components/newsletter-banner'

const SurveyResults = ({retrievedProducts, surveyAnswers}) => {
    const styles = useMultiStyleConfig('HelpMeChoose')

    return (
        <Flex {...styles.resultsInnerContainer} flexDirection="column">
            <CompareProvider>
                <Flex {...styles.retrievedProductsContainer}>
                    {retrievedProducts?.map((product, i) => {
                        return i < 3 ? (
                            <ProductTile
                                key={product.id}
                                data-testid={`survey-product-tile ${product.id}`}
                                enableFavourite
                                isFavourite={false}
                                product={product}
                                productIndex={i}
                                dynamicImageProps={styles?.retrievedProductsImageProps}
                                shouldHideCompare
                                shouldHideReviews
                                shouldHideVariants
                            />
                        ) : (
                            <></>
                        )
                    })}
                </Flex>
            </CompareProvider>
            <NewsletterBanner
                id="product-registration-newsletter"
                surveyAnswers={surveyAnswers}
                retrievedProducts={retrievedProducts}
            />
        </Flex>
    )
}

SurveyResults.propTypes = {
    retrievedProducts: PropTypes.array,
    surveyAnswers: PropTypes.object,
}
export default SurveyResults
